export class ExtendableError extends Error {
  constructor(message, extras = {}) {
    super(message);
    this.stack = Error(message).stack;
    this.name = this.constructor.name;
    Object.keys(extras).forEach(key => (this[key] = extras[key]));
  }
}
